export default __webpack_public_path__ + "static/media/icon_ovm_deploy.ac2d7b10.svg";